import { config, handleResponse } from '../../_helpers';

export const siArchiveServices = {
    getPostedWaybillPerYear,
    getPostedWaybillPerMonth,
    getPostedWaybillPerVessel,
    getPostedWaybillPerVoyage,
    getPostedWaybills,
}

function getPostedWaybillPerYear() {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/SIPostingArchiving/getPostedWaybillPerYear`, requestOptions).then(handleResponse);
}

function getPostedWaybillPerMonth(year) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/SIPostingArchiving/getPostedWaybillPerMonth/${year}`, requestOptions).then(handleResponse);
}

function getPostedWaybillPerVessel(month) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/SIPostingArchiving/getPostedWaybillPerVessel/${month}`, requestOptions).then(handleResponse);
}

function getPostedWaybillPerVoyage(vessel, year, month, search) {
    const requestOptions = {
        method: 'GET'
    };
    if(search){
        return fetch(`${config.apiUrl}/SIPostingArchiving/getPostedWaybillPerVoyage/${vessel}?year=${year}&month=${month}&search=${search}`, requestOptions).then(handleResponse);
    }
    else{
        return fetch(`${config.apiUrl}/SIPostingArchiving/getPostedWaybillPerVoyage/${vessel}?year=${year}&month=${month}`, requestOptions).then(handleResponse);
    }
}

function getPostedWaybills(voyage) {
    const requestOptions = {
        method: 'GET'
    };
    // return fetch(`${config.apiUrl}/SIPostingArchiving/getPostedWaybills/${voyage}`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/SIPostingArchiving/getPostedWaybillsV1/${voyage}`, requestOptions).then(handleResponse);
}